<template>
  <BaseDialogButton
    width="450"
    :disabled="disabled"
    :buttonText="i18n.t('_InviteUser')"
    buttonIcon="mdi-account-plus"
    :title="i18n.t('_InviteUser')"
    @cancel="cancel"
    :actions="[
      {
        color: 'primary',
        buttonText: i18n.t('_InviteUser'),
        method: this.confirm
      }
    ]"
  >
    <template slot="content">
      <v-form ref="form" v-model="valid">
        <v-text-field
          v-model="username"
          :label="i18n.t('_Username') + ' *'"
          :rules="usernameRules"
          data-cy="tf-username"
        ></v-text-field>
      </v-form>
    </template>
  </BaseDialogButton>
</template>
<script>
import i18n from "../helper/i18n"
export default {
  data() {
    return {
      valid: false,
      username: "",
      usernameRules: [v => !!v || this.i18n.t("__RulesUsername1")],
      i18n:i18n
    };
  },
  props: {
    text: String,
    disabled: {
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  methods: {
    cancel() {
      this.username = "";
      this.$refs.form.resetValidation();
    },
    confirm() {
      this.$emit("canDo", this.username.toLowerCase());
      this.username = "";
      this.$refs.form.resetValidation();
    }
  }
};
</script>

<style></style>
